import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import styles from './Badge.scss';
var Badge = /** @class */ (function (_super) {
    __extends(Badge, _super);
    function Badge() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Badge.prototype.render = function () {
        var title = this.getBadgeTitle();
        return (React.createElement("div", { className: classnames(styles['root'], styles["badge-" + this.props.name], this.props.className), title: title }, this.props.images.map(function (image, index) {
            var imageClassnames = image.className
                ? image.className.split(' ')
                : [];
            return (React.createElement("img", { key: index, src: image.imageUrl, className: classnames(styles['badge-image'], imageClassnames.map(function (c) { return styles[c]; })), alt: title }));
        })));
    };
    Badge.prototype.getBadgeTitle = function () {
        var title = this.props.title;
        if (this.props.description) {
            title += ": " + this.props.description;
        }
        if (this.props.stackCount) {
            title += " (" + this.props.stackCount + ")";
        }
        return title;
    };
    return Badge;
}(React.Component));
export default Badge;
//# sourceMappingURL=Badge.js.map